import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { MetricValueType } from '../../../../interface/dtos';

export interface ChallengeTimeInAppsEntityProps {
  value: number;
  count: number;
  userId?: string;
  userCount?: number;
  date?: string;
  type?: MetricValueType;
}

export class ChallengeTimeInAppsEntity extends Entity<ChallengeTimeInAppsEntityProps> {
  protected _id: string;
  static create(
    props: ChallengeTimeInAppsEntityProps,
    entityId?: string
  ): ChallengeTimeInAppsEntity {
    const id = entityId || v4();
    const entity = new ChallengeTimeInAppsEntity({
      id,
      props,
    });
    return entity;
  }
  public validate() {}

  get count() {
    return this.props.count;
  }
  get value() {
    return this.props.value;
  }
  get date() {
    return new Date(this.props.date);
  }
  get userId() {
    return this.props.userId;
  }
  get avg() {
    return this.count > 0 ? this.value / this.count : this.value;
  }
  get type(): MetricValueType {
    return this.props.type;
  }
  setType(type: MetricValueType): MetricValueType {
    this.props.type = type;
    return this.props.type;
  }
  get userCount(): number {
    return this.props.userCount || 0;
  }
}
